const deepFlatChildrenOfType = (obj, ...types) => {
    const result = [];
    result.push(...obj.children.filter(child => types.includes(child.type)));
    obj.children.forEach(child => result.push(...deepFlatChildrenOfType(child, ...types)));
    return result;
};

export { deepFlatChildrenOfType };
//# sourceMappingURL=deep-flat-children-of-type.js.map
